module.exports = __webpack_public_path__ + "static/jeremy-bw-sq-sm.5fd80c70.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/jeremy-bw-sq-sm.jpeg
// module id = 456
// module chunks = 144251824217401